import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-category-option',
	templateUrl: './category-option.component.html',
	styleUrls: ['./category-option.component.css']
})
export class CategoryoptionComponent implements OnInit {
	categoryForm: any;

	modalTitle: String = "Add category";
	categoryList: any = [];
	category_language = "";
	category_languagId = "";
	category_text = "";
	category: any;
	edit_id = '';
	category_edit_id = null;
	is_category_edit = false;
	languageList:any = [];

	constructor(
		private commonService: CommonService,
		private authService: AuthService,
		private router: Router,
		private validationService: ValidationService,
		private pagerService: PagerService,
		private activatedRoute: ActivatedRoute
	) { }

	ngOnInit() {
		$(".navbar-brand").text("Category");

		this.categoryForm = new FormGroup({
			category: new FormControl("", Validators.compose([Validators.required])),
			category_language: new FormControl("", Validators.compose([null])),
			category_name: new FormControl("", Validators.compose([null])),
		});

		this.activatedRoute.params.subscribe((params: any) => {
			this.edit_id = params.id;
			if (params.id) {
				this.getSingleCategory(this.edit_id);
			}
		});
		


		this.authService.getLanguageList().subscribe(data => {
			if (data.success) {
				this.languageList = data.language;
			}
		});

	}

	


	addCategory = function () {
		var category_language = this.categoryForm.controls['category_language'].value;
		var category_name = this.categoryForm.controls['category_name'].value;

		if (this.is_category_edit) {

			this.categoryList[this.category_edit_id].category_language = category_language;
			this.categoryList[this.category_edit_id].category_name = category_name;

			this.categoryForm.controls['category_language'].setValue(null);
			this.categoryForm.controls['category_name'].setValue(null);

			this.is_category_edit = false;
			this.category_edit_id = null;
		} else {

			if (category_language && category_name) {

				if (!this.categoryList.some((item) => item.category_language == category_language)) {
					this.categoryList.push({
						'category_language': category_language,
						'category_name': category_name,
					});
				}
				this.categoryForm.controls['category_language'].setValue(null);
				this.categoryForm.controls['category_name'].setValue(null);
			}else{
				jQuery.growl.error({ title: 'Error', message: 'Please fill out all required fields' });
			}

		}

	}

	getSingleCategory = function (cat_id) {

		this.authService.getSingleCategory(cat_id).subscribe(data => {
			if (data.success) {
				this.categoryList = data.result.category_language;
				this.categoryForm.controls['category'].setValue(data.result.category);
				// jQuery.growl.notice({ title: 'Success', message: data.message });
			} else {
				jQuery.growl.error({ title: 'Error', message: data.error });
			}

			this.authService.cancelProcess();
		});

	}

	deleteCategory = function (index) {
		this.categoryList.splice(index, 1)
	}

	editUpdate = function (i) {
		this.category_edit_id = i;
		this.is_category_edit = true;
		this.categoryList[i];
		this.categoryForm.controls['category_language'].setValue(this.categoryList[i].category_language);
		this.categoryForm.controls['category_name'].setValue(this.categoryList[i].category_name);
	}

	saveCategory = function () {

		var category = this.categoryForm.controls['category'].value;
		if (category == null || category == '') {
			return false;
		}

		this.commonService.process();
		let requestObject = {
			category: category,
			language: this.categoryList
		}

		if (this.edit_id) {

			requestObject['id'] = this.edit_id;

			this.authService.updateCategory(requestObject).subscribe(data => {
				if (data.success) {
					this.categoryForm.reset();
					jQuery.growl.notice({ title: 'Success', message: data.message });
					this.router.navigate(['category']);
				} else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				this.authService.cancelProcess();
			});

		} else {

			this.authService.addCategory(requestObject).subscribe(data => {
				if (data.success) {
					this.categoryForm.reset();
					jQuery.growl.notice({ title: 'Success', message: data.message });
					this.router.navigate(['category']);
				} else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				this.authService.cancelProcess();
				
			});

		}


	}

	// 	// Get category List
	// 	getCategoryList = function (pageNo, limit) {
	// 		this.commonService.process();
	// 		this.authService.getSurveyCategoryList(pageNo, limit).subscribe(data => {
	// 			if (data.success) {
	// 				this.categoryList = data.category;
	// 				this.total = data.total;
	// 				this.setPage(pageNo, true);
	// 				this.pageNo = pageNo;
	// 			}
	// 			this.commonService.hideProcess();
	// 		});
	// 	}

	// 	// Pagination
	// 	setPage(page: number, param) {
	// 		if (page < 1 || page > this.pager.totalPages) {
	// 			return;
	// 		}
	// 		//this.pageNo = page;
	// 		this.pager = this.pagerService.getPager(this.total, page);

	// 		// get current page of items
	// 		this.pagedItems = this.categoryList.slice(this.pager.startIndex, this.pager.endIndex + 1);
	// 		if (!param) {
	// 			this.getCategoryList(page, this.limit);
	// 		}
	// 	}

	// 	// addCategory
	// 	addCategory = function () {
	// 		this.isActivatedAdd = true;
	// 		this.isActivatedEdit = false;
	// 		this.isActivatedDelete = false;
	// 		this.modalTitle = "Add Category";
	// 		this.btnTitle = "Save";
	// 		this.selectedCategoryId = "";
	// 		this.categoryForm.reset();
	// 	}

	// 	// Update selected category
	// 	updateSelectedCategory = function (category) {
	// 		this.isActivatedAdd = false;
	// 		this.isActivatedEdit = true;
	// 		this.isActivatedDelete = false;
	// 		this.modalTitle = "Update Category";
	// 		this.btnTitle = "Update";
	// 		this.selectedCategoryId = category._id;
	// 		this.categoryForm.controls['category'].setValue(category.category);

	// 		this.authService.getSingleCategory(this.selectedCategoryId).subscribe(data => {
	// 			if (data.success) {
	// 				console.log(data.result);
	// 				this.categoryForm.controls['category_arabic'].setValue(data.result.category_arabic);
	// 				this.categoryForm.controls['category_hindi'].setValue(data.result.category_hindi);
	// 				this.categoryForm.controls['category_latin'].setValue(data.result.category_latin);
	// 				this.categoryForm.controls['category_french'].setValue(data.result.category_french);
	// 			}
	// 		});

	// 		console.log(category);
	// 	}

	// 	// Delete Selected Category
	// 	deleteSelectedCategory = function (category) {
	// 		this.isActivatedAdd = false;
	// 		this.isActivatedEdit = false;
	// 		this.isActivatedDelete = true;
	// 		this.modalTitle = "Delete Category";
	// 		this.btnTitle = "Yes";
	// 		this.selectedCategoryId = category._id;
	// 		this.category = category;

	// 	}

	// 	// manage new category
	// 	manageCategory = function (category) {

	// 		if (this.categoryForm.valid && this.isActivatedAdd) {
	// 			this.btnTitle = "Saving...";
	// 			jQuery(':button[type="submit"]').attr('disabled', true);
	// 			console.log(category);

	// 			this.authService.manageCategory(category, "add").subscribe(data => {
	// 				if (data.success) {
	// 					jQuery.growl.notice({ title: 'Success', message: data.message });
	// 					this.getCategoryList(1, this.limit);
	// 				}
	// 				else {
	// 					jQuery.growl.error({ title: 'Error', message: data.error });
	// 				}
	// 				jQuery(':button[type="submit"]').attr('disabled', false);
	// 				this.authService.cancelProcess();
	// 			});
	// 		} else if (this.categoryForm.valid && this.isActivatedEdit) {
	// 			category._id = this.selectedCategoryId;
	// 			this.btnTitle = "Updating...";
	// 			jQuery(':button[type="submit"]').attr('disabled', true);
	// 			this.authService.manageCategory(category, "update").subscribe(data => {
	// 				if (data.success) {
	// 					this.getCategoryList(this.pageNo, this.limit);
	// 					jQuery.growl.notice({ title: 'Success', message: data.message });
	// 				}
	// 				else {
	// 					jQuery.growl.error({ title: 'Error', message: data.error });
	// 				}
	// 				jQuery(':button[type="submit"]').attr('disabled', false);
	// 				this.authService.cancelProcess();
	// 			});
	// 		} else if (this.isActivatedDelete) {
	// 			category._id = this.selectedCategoryId;
	// 			this.btnTitle = "Deleting...";
	// 			jQuery(':button[type="submit"]').attr('disabled', true);
	// 			this.authService.manageCategory(category, "delete").subscribe(data => {
	// 				if (data.success) {
	// 					this.getCategoryList(this.pageNo, this.limit);
	// 					jQuery.growl.notice({ title: 'Success', message: data.message });
	// 				}
	// 				else {
	// 					jQuery.growl.error({ title: 'Error', message: data.error });
	// 				}
	// 				jQuery(':button[type="submit"]').attr('disabled', false);
	// 				this.authService.cancelProcess();
	// 			});
	// 		}
	// 		else {
	// 			this.validationService.validateAllFormFields(this.categoryForm);
	// 		}
	// 	}

}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/category-option/category-option.component.ts